import {
  AppBar as MuiAppBar,
  AppBarProps,
  Box,
  Button,
  Container,
  styled,
  Toolbar,
  Typography,
  Stack,
} from "@mui/material";
import LogoImage from "@/assets/logo_black.svg"
import {Link} from "react-router-dom";
import {Wrench} from "lucide-react";

const pages = [
  {
    name: '売買無料便利ツール',
    path: '/zyusetu/tools',
    subMenu: [
      {name: '延床面積計算', path: '/zyusetu/tools/area-calculator'},
      {name: '管理規約抽出', path: '/zyusetu/tools/bylaw-extractor'},
    ]
  }
];

interface ResponsiveAppBarProps {
  open: boolean;
}

const drawerWidth = 240;
const miniDrawerWidth = 65;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({theme}) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({open}: { open: boolean }) => open,
      style: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
    {
      props: ({open}: { open: boolean }) => !open,
      style: {
        width: `calc(100% - ${miniDrawerWidth}px)`,
        marginLeft: `${miniDrawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

export function ResponsiveAppBar({
                                   open,
                                 }: ResponsiveAppBarProps) {
  
  return (
    // @ts-expect-error open prop is passed on custom style component
    <AppBar position="static" color={'inherit'} elevation={0} open={open}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{height: '64px'}}>
          {/* ハンバーガーメニューはDrawerに統合 */}
          <Link to={"/"} style={{height: '100%'}}>
            <img src={LogoImage} style={{height: '100%', padding: 9}}/>
          </Link>
          <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}, ml: 3}}>
            {pages.map((page) => (
              <Box key={page.name}>
                <Button
                  component={Link}
                  to={page.path}
                  sx={{my: 2, display: 'block', color: "black"}}
                >
                  <Stack direction={'row'}><Wrench/><Typography
                    fontWeight={'bold'}> {page.name}</Typography></Stack>
                </Button>
              </Box>
            ))}
          </Box>
          <Box sx={{flexGrow: 0}}/>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
